// REACT & Libraries
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs, P, H5 } from "../../../AbstractElements";

// Table
import JobLevelTable from "../../DataTables/MasterData/JobLevel/JobLevelTable";

// Modals
import CreateJobLevelModal from "../../UiKits/Modal/MasterData/JobLevel/CreateJobLevel";

const JobLevelContainer = () => {
  return (
    <>
      <Breadcrumbs
        mainTitle="Job Level / Rank"
        parent="Master Data / Employment"
      />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <H5 className="mb-0">Master Data Management</H5>
                <P className="mb-3 f-light f-w-200 f-12">
                  Manage job level / rank status options used throughout the
                  HRIS for employee and applicant personal information.
                </P>
                <CreateJobLevelModal />
                <JobLevelTable />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default JobLevelContainer;
